export default __webpack_public_path__ + "static/media/international_camp_photo[1].5a3cf902.png";